import { environment } from 'src/environments/environment';

export const ApiConstants = {
  URL: {
    login: '/v1/auth/login',
    logout: '/v1/auth/logout',
    listDevice: '/v1/devices/devices',
    blobUpload: `${environment.azureBlobBaseUrl}`,
    getCreateNDevices: '/v1/devices/createNDevices',
    getdevicePayload: '/v1/devices/devicePayload',
    getDeviceRealTimeData: '/v1/devices/realTimeData',
    devicesSummary: '/v1/devices/summary',
    createTemplate: '/v1/templates/createTemplate',
    updateTemplate: '/v1/templates/updateTemplate',
    deleteBatchTemplate: '/v1/templates/deleteTemplate',
    templateMapped: '/v1/templates/templateMapped',
    getTemplate: '/v1/templates/templates',
    getTemplateId: '/v1/templates/templatebyId',
    templatesSummary: '/v1/templates/summary',
    batches: '/v1/batches/batches',
    createBatch: '/v1/batches/createBatch',
    updateBatch: '/v1/batches/updateBatch',
    deleteBatch: '/v1/batches/deleteBatch',
    getBatchUnmappedDevices: '/v1/batchDevices/getBatchUnmappedDevices',
    getSimulatorBatchDevices: '/v1/batchDevices/mapSimulatorBatchDevices',
    getDeviceTemplateDetails: '/v1/batchDevices/getBatchDeviceTemplateDetails',
    updateBatchStatus: '/v1/batches/action',
    deleteDevice: '/v1/devices',
    batchesSummary: '/v1/batches/summary',
    getTenants: '/v1/external/tenants',
    generateSasToken: '/v1/utilities/generateSasToken',
    attributeDetails: '/v1/settings/attributeDetails',
    features: '/v1/users/features',
    detachDevices: '/v1/batchDevices/unmapEchoBatchDevices',

    //V2 API's
    templateV2: '/v2/templates',
    templatesSummaryV2: '/v2/templates/summary',
    getAttachedBatchV2: '/v2/templates/templateBatches',
    batchV2: '/v2/batches',
    batchesSummaryV2: '/v2/batches/summary',
    updateBatchStatusV2: '/v2/batches/action',
    mapEchoBatchDevicesV2: '/v2/batchDevices/mapEchoBatchDevices',
    getBatchUnmappedDevicesV2: '/v2/batchDevices/getBatchUnmappedDevices',
    getDeviceTemplateDetailsV3: '/v3/batchDevices/getBatchDeviceTemplateDetails',
    getBatchPayloadMetricsV2: '/v2/batches/payloadMetrics',
    createDevicesV2: '/v2/devices/createNDevices',
    deviceSummaryV2: '/v2/devices/summary',
    listDeviceV2: '/v2/devices/devices'
  },
  APP_TOKEN: environment?.appToken,
  API_ENDPOINT: environment?.apiEndPoint,
  BLOB_CONTAINER: environment?.blobContainer
};
